import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {DdmsBastStates} from "./types/DdmsBastTypes ";
import {ddmsInvoiceApiService} from "../../services/otodis/DdmsInvoiceApiService";
import {Button, Col, DatePicker, Form, Modal, Result, Row, Spin, Table, Tabs, Tooltip} from "antd";
import {FormOutlined, LeftOutlined, SaveOutlined, SearchOutlined} from "@ant-design/icons";
import moment from "moment";

const {TabPane} = Tabs;

export interface DdmsBastProps {
}

class DdmsBast extends Component<DdmsBastProps & any, DdmsBastStates> {
    private readonly initState!: DdmsBastStates;
    private tableColumn: any = [
        {
            title: 'ID Order Daya',
            dataIndex: 'DayaIdOrder',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'Nomor Mesin',
            dataIndex: 'VehicleEngineNumber',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'Tanggal BAST Daya',
            dataIndex: 'DayaBastDate',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        }
    ];

    private tableResult: any = [
        {
            title: 'Kode Order',
            dataIndex: 'order_code',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'Nomor Mesin',
            dataIndex: 'vehicle_engine_number',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
        {
            title: 'Nama Konsumen',
            dataIndex: 'customer_name',
            render: (value: string) => {
                return <span className={`font-90`}>{value}</span>
            }
        },
    ];

    constructor(props: DdmsBastProps & any | any) {
        super(props);
        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            startDate: moment().clone().format('YYYY-MM-DD'),
            endDate: moment().clone().format('YYYY-MM-DD'),
            orderMonth: moment().clone().format('YYYY-MM'),
            fetchDdms: false,
            dataDdms: [],
            countDataDdms: 0,
            tabKey: "1",
            finalLoadingModal: false,
            saveProcessing: false,
            modalConfirm: false,
            modalResult: false,
            listResult: [],
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
        });
    }

    onchangeStartDate = (data: any) => {
        if (data) {
            this.setState({
                startDate: data,
            });
        }
    }

    onchangeEndDate = (data: any) => {
        if (data) {
            this.setState({
                endDate: data,
            });
        }
    }

    onchangeOrderMonth = (data: any) => {
        if (data) {
            this.setState({
                orderMonth: data,
            });
        }
    }

    cancelProcess = async () => {
        await this.promisedSetState({
            tabKey: "1",
            dataDdms: [],
            countDataDdms: 0,
        });
    }

    fetchDataDdms = async () => {
        await this.promisedSetState({
            fetchDdms: true,
            listResult: [],
            finalLoadingModal: true,
        });

        try {
            await ddmsInvoiceApiService.getBast({
                dealerCode: this.state.dealerCode,
                startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
                endDate: moment(this.state.endDate).format("YYYY-MM-DD"),
            }).then(async value => {
                await this.promisedSetState({
                    tabKey: "2",
                    fetchDdms: false,
                    finalLoadingModal: false,
                    dataDdms: value.data.data,
                    countDataDdms: value.data.total_data,
                });
            })
        } catch (e) {
            await this.promisedSetState({
                tabKey: "1",
                fetchDdms: false,
                finalLoadingModal: false,
                dataDdms: [],
                countDataDdms: 0,
            });
            Modal.error({
                title: 'Proses Gagal',
                content: '' + e
            });
        }

    }

    onSaveData = async () => {
        this.setState({
            modalConfirm: true,
        });
    }

    closeModalConfirm = async () => {
        this.setState({
            modalConfirm: false,
        });
    }

    closeModalResult = async () => {
        this.setState({
            modalResult: false,
        });
    }

    okModalConfirm = async () => {
        await this.promisedSetState({
            saveProcessing: true,
        });

        try {
            await ddmsInvoiceApiService.saveBast({
                dealer_code: this.state.dealerCode,
                total_data: this.state.countDataDdms,
                start_date: moment(this.state.orderMonth).startOf('month').format("YYYY-MM-DD"),
                end_date: moment(this.state.orderMonth).endOf('month').format("YYYY-MM-DD"),
                data_document: this.state.dataDdms
            }).then(async dataInsert => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Data berhasil diinput. '
                });

                await this.cancelProcess();
                await this.promisedSetState({
                    listResult: dataInsert?.data.data_processed,
                    modalResult: true,
                    saveProcessing: false,
                    modalConfirm: false,
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                saveProcessing: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Dokumen`} breadcrumbMenu={`BAST DDMS`} defaultSelectedKeys={['m-get-ddms-bast']} defaultOpenKeys={['sm-document']}>

                    <Tabs activeKey={this.state.tabKey.toString()}>
                        <TabPane tab="Cari Data BAST DDMS" disabled={true} key="1">
                            <Result
                                icon={<FormOutlined/>}
                                title="Pencarian data BAST DDMS"
                                extra={<div>
                                    <Row>
                                        <Col xs={24} xl={6} className={`pad-10`}/>
                                        <Col xs={24} xl={6} className={`pad-10`}>
                                            <Form.Item>
                                                <i className={`small-text-grey`}>Tgl Awal Input DDMS</i>
                                                <DatePicker value={moment(this.state.startDate, 'YYYY-MM-DD')} onChange={event => this.onchangeStartDate(event)} format={'YYYY-MM-DD'} style={{width: "100%"}}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} className={`pad-10`}>
                                            <Form.Item>
                                                <i className={`small-text-grey`}>Tgl Akhir Input DDMS</i>
                                                <DatePicker value={moment(this.state.endDate, 'YYYY-MM-DD')} onChange={event => this.onchangeEndDate(event)}
                                                            format={'YYYY-MM-DD'} style={{width: "100%"}}/>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={6} className={`pad-10`}/>
                                    </Row>

                                    <br/>
                                    <Button onClick={this.fetchDataDdms} loading={this.state.fetchDdms} type="primary" icon={<SearchOutlined/>}>Cari BAST DDMS</Button>
                                </div>}
                            />
                        </TabPane>
                        <TabPane tab="Simpan BAST" disabled={true} key="2">

                            <div>
                                <Tooltip title="Batalkan Proses Simpan">
                                    <Button shape="circle" icon={<LeftOutlined/>} onClick={this.cancelProcess}/>
                                </Tooltip>

                                <Button type={'primary'}
                                        style={{marginLeft: 15}}
                                        icon={<SaveOutlined/>}
                                        onClick={this.onSaveData}
                                >Simpan Data</Button>
                            </div>
                            <br/><br/>

                            <Table
                                rowKey={'warehouse_code'}
                                size={'small'}
                                scroll={{x: 'calc(500px + 50%)'}}
                                loading={this.state.fetchDdms}
                                columns={this.tableColumn}
                                dataSource={this.state.dataDdms}
                                pagination={{pageSize: 10000}}
                            />
                        </TabPane>
                    </Tabs>

                    <Modal
                        visible={this.state.finalLoadingModal}
                        closeIcon={true}
                        footer={null}
                    >
                        <div style={{textAlign: "center", padding: 20, minHeight: 100}}>
                            <Spin style={{marginTop: 20}} size={'large'} tip="Processing..."/>
                        </div>

                        <div style={{textAlign: "center", padding: 20}}>
                            Proses pengambilan data ke DDMS <br/>
                            Mohon menunggu beberapa saat.
                        </div>
                    </Modal>

                    <Modal
                        visible={this.state.modalConfirm}
                        title="Konfirmasi Simpan"
                        closeIcon={true}
                        footer={[
                            <Button key="1" type="primary" loading={this.state.saveProcessing} onClick={this.okModalConfirm}>
                                Simpan
                            </Button>,
                            <Button key="2" loading={this.state.saveProcessing} onClick={this.closeModalConfirm}>
                                Cancel
                            </Button>,
                        ]}
                    >
                        <Form layout={"vertical"}>
                            Silakan memilih bulan order untuk pemenuhan faktur.
                            <Form.Item label="Bulan Order">
                                <DatePicker picker="month" value={moment(this.state.orderMonth, 'YYYY-MM')} onChange={event => this.onchangeOrderMonth(event)} format={'YYYY-MM'} style={{width: "100%"}}/>
                            </Form.Item>
                        </Form>
                    </Modal>

                    <Modal
                        visible={this.state.modalResult}
                        title="Konfirmasi Simpan"
                        closeIcon={true}
                        width={'75%'}
                        footer={[
                            <Button key="1" type="primary" onClick={this.closeModalResult}> Close</Button>,
                        ]}
                    >
                        Berikut merupakan hasil data yang terupdate (silakan copy data jika dibutuhkan):<br/><br/>

                        <Table
                            rowKey={'order_code'}
                            size={'small'}
                            scroll={{x: 'calc(500px + 50%)'}}
                            columns={this.tableResult}
                            dataSource={this.state.listResult}
                            pagination={{pageSize: 10000}}
                        />

                    </Modal>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(DdmsBast), 20));
